import { PieChart } from "./PieChart";
import { getClassement } from "./getClassement";

export const MatchsPieDef = ({ playerData, matchs }) => {
  const normalLoss = matchs.data.filter(
    (item) =>
      item.victoire === "D" &&
      getClassement(item.classement) > playerData.ptsOff,
  ).length;
  const anormalLoss = matchs.data.filter(
    (item) =>
      item.victoire === "D" &&
      getClassement(item.classement) < playerData.ptsOff,
  ).length;

  return (
    <>
      <h3>Défaites</h3>
      <div className="matchs-pie">
        <PieChart
          data={[
            { label: "Contre", value: anormalLoss, color: "#eb525c" },
            { label: "Normales", value: normalLoss, color: "#377EB8" },
          ]}
        />
      </div>
    </>
  );
};
